var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"height":"400","transition":"scale-transition","type":"image"}},[_c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.series,"height":"auto","type":"radar"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }